import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

const BoxInfoSuccess = ({ title, subtitle }) => {
  return (
    <div className="form-group form-register bg-white rounded py-2 px-4 text-center">
      <FontAwesomeIcon icon={faCheckCircle} style={{ fontSize: 120, color: '#5C0989', marginTop: 10 }} />
      <h4 className="mb-2 mt-4">{title}</h4>

      {typeof subtitle === 'string' ? <p>{subtitle}</p> : subtitle}
    </div>
  );
}

export default BoxInfoSuccess;